import type { Moneda } from '../types';

/** Formatea solo el número (sin símbolo de moneda) usando separadores es-AR */
export function formatAmount(value: number, moneda: Moneda = 'ARS'): string {
  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: moneda === 'USD' ? 2 : 0,
  }).format(Math.abs(value));
}

export function formatCurrency(value: number, moneda: Moneda = 'ARS'): string {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: moneda,
    minimumFractionDigits: moneda === 'USD' ? 2 : 0,
    maximumFractionDigits: moneda === 'USD' ? 2 : 0,
  }).format(Math.abs(value));
}

export function formatPercent(value: number): string {
  return `${value}%`;
}

export function formatCurrencyCompact(value: number, moneda: Moneda = 'ARS'): string {
  if (moneda === 'ARS' && Math.abs(value) >= 1_000_000) {
    return `${moneda === 'ARS' ? '$' : 'USD '}${(value / 1_000_000).toFixed(1)}M`;
  }
  return formatCurrency(value, moneda);
}
